import { render, staticRenderFns } from "./HeatingPeriodList.vue?vue&type=template&id=96e97c44&scoped=true&"
import script from "./HeatingPeriodList.vue?vue&type=script&lang=js&"
export * from "./HeatingPeriodList.vue?vue&type=script&lang=js&"
import style0 from "./HeatingPeriodList.vue?vue&type=style&index=0&id=96e97c44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e97c44",
  null
  
)

export default component.exports